import { render } from "./Peyment.vue?vue&type=template&id=a244c970&scoped=true"
import script from "./Peyment.vue?vue&type=script&lang=js"
export * from "./Peyment.vue?vue&type=script&lang=js"

import "./Peyment.vue?vue&type=style&index=0&id=a244c970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a244c970"]])

export default __exports__